/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitPrivacyStatusEnum = {
    LoadFailure: 'load_failure',
    ParseFailure: 'parse_failure',
    Blocked: 'blocked',
    Success: 'success',
    ContentTooLarge: 'content_too_large'
} as const;
export type MonitPrivacyStatusEnum = typeof MonitPrivacyStatusEnum[keyof typeof MonitPrivacyStatusEnum];


export function MonitPrivacyStatusEnumFromJSON(json: any): MonitPrivacyStatusEnum {
    return MonitPrivacyStatusEnumFromJSONTyped(json, false);
}

export function MonitPrivacyStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPrivacyStatusEnum {
    return json as MonitPrivacyStatusEnum;
}

export function MonitPrivacyStatusEnumToJSON(value?: MonitPrivacyStatusEnum | null): any {
    return value as any;
}

